<template>
  <svg width="34" height="30" viewBox="0 0 34 30" fill="#888888" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="7" width="26" height="2" rx="1"/>
    <rect x="4" y="14" width="26" height="2" rx="1"/>
    <rect x="4" y="21" width="26" height="2" rx="1"/>
  </svg>
</template>